<template>
  <div class="item_main" @click="gotoPage">
    <img class="img_item_main" :src="lujing" alt="" />
    <p style="margin-top: 10px; font-size: 16px; color: #333; word-break: break-all; height:24px; overflow:hidden;">
      {{ mes.courseName }}
    </p>
    <div class="teacher">
      <span style="flex:2; white-space:nowrap; overflow: hidden; text-overflow: ellipsis;">讲师:{{ mes.teacherName ? mes.teacherName : "暂无教师" }}</span>
      <span style="flex:1; text-align:right">共{{ mes.courseNumber }}课时</span>
    </div>
    <div class="jiage">
      <span>￥{{ mes.discountPrice | priceStyle }}</span>
      <!-- <span v-if="mes.discountPrice!=mes.originalPrice">￥{{ mes.originalPrice | priceStyle}}</span> -->
    </div>
  </div>
</template>

<script>
import role from "../minxins/role";
export default {
  data() {
    return {
      imgDizhi: "",
      lujing: "",
    };
  },
  mixins: [role],
  props: {
    mes: Object,
  },
  filters:{
    priceStyle(v){
      if(!v) return 0;
      return v.toFixed(2);
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.imgDizhi = this.userModule.fileUrl;
      if (!this.mes.imagePath) {
        this.lujing = "../../static/img/img1.png";
      } else {
        this.lujing = this.imgDizhi + this.mes.imagePath;
      }
    },
    gotoPage() {
      this.$router.push({
        name: "purchaseDetails",
        params: { id: this.mes.id,type:this.mes.courseClassify},
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/detail.vue